import { CardTitle } from "$components/card";
import { Grid } from "@material-ui/core";
import { FormattedMessage } from "react-intl";

const LegacyPrescription = () => (
  <Grid container>
    <Grid item>
      <CardTitle>
        <FormattedMessage
          id="patient.history.prescription.legacyTitle"
          defaultMessage="Legacy Prescription"
        />
      </CardTitle>
    </Grid>
  </Grid>
);

export { LegacyPrescription };
